import styled from 'styled-components';

import { BaseStyledComponentProps } from '../../../utils/styles-constants';
import { StyledMenu, StyledMenuButton } from '../../DropdownMenu/styles';

interface ButtonProps {
	isMenuDisplayed: boolean;
}

const Wrapper = styled('div')`
	position: relative;

	${StyledMenu} {
		left: auto;
		right: 0;
		width: 200px;
	}

	${StyledMenuButton} svg {
		width: 20px;
		height: 20px;
		fill: currentColor;
	}
`;

const Button = styled('button')`
	min-width: 50px;
	padding: 5px 10px;
	border: 0;
	outline: 0;
	font-family: HelveticaNeue, sans-serif;
	font-size: 12px;
	line-height: 20px;
	background-color: transparent;
	color: ${(props: BaseStyledComponentProps) => props.theme.primary.actionColor};

	cursor: pointer;

	svg {
		width: 7px;
		height: 8px;
		margin-left: 5px;
		fill: currentColor;

		${({ isMenuDisplayed }: ButtonProps) => isMenuDisplayed && 'transform: rotate(180deg);'}
	}
`;

export {
	Wrapper,
	Button,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/DriveItemList/DisplayTypeDropdown/styles.ts